import type { ExpenseStatus } from "@/api/types";
import { isSentBack, shortDate, statusLabel, statusTone } from "@/format";

export function StatusBadge({
  report,
}: {
  report: { status: ExpenseStatus; submittedAt: string | null; reimbursementDate?: string | null };
}) {
  const back = isSentBack(report);
  return (
    <span className={`badge ${statusTone(report.status, back)}`}>
      {statusLabel(report.status, back)}
      {report.status === "Paid" && report.reimbursementDate
        ? ` · reimbursed ${shortDate(report.reimbursementDate)}`
        : ""}
    </span>
  );
}
